import React from 'react';
import { Route } from 'react-router-dom';
import PanelLayout from './PanelLayout';
import DashboardPage from './pages/DashboardPage';
import AccountsPage from './pages/AccountsPage';
import ReferenceSourcesPage from './pages/ReferenceSourcesPage';
import ContentQueuePage from './pages/ContentQueuePage';
import SchedulePage from './pages/SchedulePage';
import MetricsPage from './pages/MetricsPage';
import BillingPage from './pages/BillingPage';

export const panelRoutes = (
  <Route path="/panel" element={<PanelLayout />}>
    <Route index element={<DashboardPage />} />
    <Route path="dashboard" element={<DashboardPage />} />
    <Route path="accounts" element={<AccountsPage />} />
    <Route path="reference-sources" element={<ReferenceSourcesPage />} />
    <Route path="content" element={<ContentQueuePage />} />
    <Route path="schedule" element={<SchedulePage />} />
    <Route path="metrics" element={<MetricsPage />} />
    <Route path="billing" element={<BillingPage />} />
  </Route>
);
